import { FeathersModel } from './feathersModel'
import { Assistant } from './assistant'
import { Assistance } from './assistance'

export class ExchangeEnrollment extends FeathersModel {
  static serviceName = 'exchange-enrollments'

  enrolledAt: Date
  assistanceId: number
  assistance: Assistance
  assistantId: number
  assistant: Assistant
  createdAt: Date
  updatedAt: Date

  constructor() {
    super(null)
  }

  public turnSubresourcesIntoFrontendModels() {
    this.assistance = this.assistance ? Assistance.createFromProps(Assistance, this.assistance) : this.assistance
    this.assistant = this.assistant ? Assistant.createFromProps(Assistant, this.assistant) : this.assistant
  }
}
